import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Subject} from "rxjs";
import {filter, map, switchMap, takeUntil} from "rxjs/operators";
import {UserSubscription} from "../../../../user/user-subscription";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Website} from "../../website";
import {TypeUtils} from "../../../../shared/utils/type-utils";


@Component({
    selector: 'db-cdn-notice',
    templateUrl: './cdn-notice.component.html',
    styleUrls: ['./cdn-notice.component.scss'],
    standalone: false
})
export class CdnNoticeComponent implements OnInit, OnDestroy {
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public userSubscription: UserSubscription;
  public website: Website;
  public isStatusPending: boolean = true;
  public hasDcvRecord: boolean = true;
  public isNameServer: boolean;

  @Input() websiteId: number;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    this._getWebsite();
    this._getCFData();
    this._getCFDefaultDnsRecord();
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }


  private _getWebsite(): void {
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() =>
          this._store.select(fromStore.getWebsite(this.websiteId))
        ),
        takeUntil(this._destroyStream$)
      )
      .subscribe((website) => {
        this.website = website;
      });
  }


  private _getCFData(): void {
    this._store.select(fromStore.getCloudflareData(this.website?.id))
      .pipe(
        filter(({cfStatus, hasDcvRecord}) => !!cfStatus && hasDcvRecord !== undefined),
        map(({cfStatus, hasDcvRecord}) => ({
          status: cfStatus === 'pending', hasDcvRecord
        }))
      )
      .subscribe(({status, hasDcvRecord}) => {
        this.isStatusPending = status;
        this.hasDcvRecord = hasDcvRecord;
      });
  }

  private _getCFDefaultDnsRecord(): void {
    this._store.select(fromStore.getCloudflareDefaultRecord(this.website?.id))
      .pipe(
        takeUntil(this._destroyStream$))
      .subscribe(data => {
        if (!TypeUtils.isNull(data) && !TypeUtils.isEmpty(data)) {
          this.isNameServer = !!data.tenwebNs;
        }
      });
  }

  public setActiveTab(): void {
    this._router.navigate([`websites/${this.websiteId}/booster/cloudflare`], {queryParams: {active_tab: 1}});
  }

}
